/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Box, Grid, TextField, Typography } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import InputMask from 'react-input-mask';

import { CTA } from '../Common/CTA';
import ApiService from '../../helpers/ApiService';
import { useAuth } from '../../providers/AuthProvider';
import { useCode } from '../../providers/CodeProvider';

const CodeRescueContainer = styled.div`
  background-color: var(--primary);
  padding: 1.5rem 2rem;
  border-radius: 1rem;
  width: 100%;

  form {
    .MuiInputBase-root {
      color: var(--bluegray-600);
      background-color: var(--white);
    }
    .MuiFormHelperText-root {
      color: var(--white);
    }
    .MuiFormControlLabel-label  {
      color: var(--white);
    }
    .MuiInputBase-input {
      text-align: center;
      font-size: 1.1rem;
    }
  }
`;
export const FormCodeRescue = () => {
  const { token, /*codeToRescue, setCodeToRescue*/ } = useAuth();
  const { setCodeNumbers } = useCode();
  const { register, handleSubmit, formState: {errors}, setError, clearErrors, setValue, control } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const maxCharacters = 17;

  const validateCode = (code) => {
    let validations = [];
    code = code.trim();
    // validations.push(code.indexOf("S") === 0); // Código inicia com 'S'
    validations.push(code.split("").length === maxCharacters); // Código maior que 20 caracteres

    return !(validations.indexOf(false) > -1);
  }

  const onSave = async data => {
    if ( !validateCode(data.code) ) {
      setError("code");
      return;
    }
    data.code = data.code.trim();
    setIsLoading(true);
    clearErrors("code");
    window.localStorage.removeItem("cupom");

    ApiService.post('code/save', data, token).then( (result) => {
      if ( result.status === 200 ) {
        Swal.fire({
          title: `Código inserido com sucesso!`,
          text: `Código cadastrado, em breve você receberá seu número da sorte`,
          icon: 'success',
          confirmButtonText: 'Obrigado'
        });
        setIsLoading(false);
        setCodeNumbers(result.data.codes);
        setValue('code', "");
        // setCodeToRescue(null);
      }
    }).catch( (error) => {
      console.error(error);
      if ( error.status === 400 ) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Código já cadastrado anteriormente.',
          confirmButtonText: "Entendi"
        });
      }
      else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Ocorreu um erro desconhecido. Tente novamente mais tarde.',
          confirmButtonText: "Entendi"
        });
      }
      setIsLoading(false);
    });
  }

  useEffect( () => {
    let mounted = true;
    if (mounted) {
      if( window.localStorage.getItem("cupom") ) {
        document.getElementById("code").value = window.localStorage.getItem("cupom");
        setValue("code", window.localStorage.getItem("cupom") );
      }

      register('code');
    }
    return () => mounted = false;
  }, []);

  return (
    <>
    <Grid item sm={3} />
    <Grid item sm={6} xs={12} align='center'>
      <CodeRescueContainer>
        <Typography variant="body1" className='white--text' align="center" mb={2}>
          Preencha o código recebido no ato da compra
        </Typography>
        <form onSubmit={handleSubmit(onSave)}>
        <Controller
          name='code'
          control={control}
          defaultValue=""
          render={ ({ field: {onChange, value}, fieldState: { error }}) => (
            <InputMask
              mask="aaaaaaaaaaaaaaaaa"
              maskChar=" "
              onChange={onChange}
              value={value}
            >
              { () => (
                <div>
                  <TextField
                    id="code"
                    variant="outlined"
                    fullWidth
                    placeholder="Digite seu código aqui"
                    name="code"
                    type="text"
                    maxLength={maxCharacters}
                    value={value}
                    onChange={onChange}
                    error={!!error}
                    helperText={errors.code && "Código inválido"}
                    disabled={isLoading}
                    inputProps={{style: {fontSize: '1.5rem'}}} // font size of input text
                    InputLabelProps={{style: {fontSize: '1.5rem'}}} // font size of input label
                  />
                </div>
              )}
            </InputMask>
          )}
          rules={{ required: 'Código obrigatório', maxLength: maxCharacters }}
        />
          <Box mt={2} mb={2}>
            <CTA type="submit" disabled={isLoading}>
              Resgatar código
            </CTA>
          </Box>
        </form>
        <Typography variant="caption" component='p' className="opacity white--text min-line" align='center'>
          Os números da sorte serão disponibilizados em até 48 horas após o resgate do código através do formulário acima.
        </Typography>
      </CodeRescueContainer>
    </Grid>
    <Grid item sm={2} />
    </>
  )
}
